<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { useLocation } from 'svelte-navigator';
  // @ts-ignore
  import mbLogo from '../assets/MB-star_p_3Coffice white.png';

  export let isAppActive = true;
  export let isStartingInFuture = false;

  const location = useLocation();

  $: isNotStartedYet = !isAppActive || isStartingInFuture;

  $: pageTitle = (() => {
    const path = $location?.pathname || '';
    if (path.includes('/step/1')) {
      return $_('Registration');
    }
    if (path.includes('/step/2')) {
      return $_('Purchase Information');
    }
    if (path.includes('/step/3')) {
      return $_('Personal Information');
    }
    if (path.includes('/step/4')) {
      return $_('Questions');
    }
    if (path.includes('/step/5')) {
      return $_('Submit Application');
    }
    return $_('Welcome');
  })();
</script>

<div class="bg-black">
  <div
    class="mx-auto flex {isNotStartedYet ? 'max-w-[50rem]' : 'max-w-7xl'} items-center justify-between px-4 py-4 sm:px-6 sm:py-5"
  >
    <div class="flex flex-1 items-center justify-start">
      <span class="font-CorpoS text-xl font-normal leading-snug text-white sm:text-2xl">
        {#if isNotStartedYet}
          <span class="block">{$_('Winterkomplettrad')}</span>
          <span class="block">{$_('Cashback-Aktion')}</span>
        {:else}
          {pageTitle}
        {/if}
      </span>
    </div>

    <div class="flex items-center justify-center">
      <img
        src={mbLogo}
        alt="Mercedes-Benz Logo"
        class="h-9 w-auto sm:h-12"
      />
    </div>

    <div class="flex flex-1 items-center justify-end text-right">
      <span class="font-CorpoS text-xl font-normal leading-snug text-white sm:text-2xl">
        {#if isNotStartedYet}
          Mercedes-Benz
        {:else}
          {$_('Mercedes-Benz Cashback-Aktion')}
        {/if}
      </span>
    </div>
  </div>
</div>


